import { useTranslation } from 'react-i18next';

import type { AdminAuction } from '@nucleus-commerce/api-client/admin';
import { useFormat } from '@nucleus-commerce/i18n/react';

import { AuctionCountdown } from './auction-countdown';

/** The list's time column: a countdown while live, the start before, the close after. */
export function AuctionWhen({ auction }: { auction: AdminAuction }) {
  const { t } = useTranslation('auctions');
  const format = useFormat();
  if (auction.status === 'live') {
    return (
      <span className="flex flex-col">
        <AuctionCountdown target={auction.endsAt} className="font-medium" />
        <span className="text-muted-foreground text-xs">
          {t('when.endsAt', { when: format.dateTime(auction.endsAt) })}
        </span>
      </span>
    );
  }
  if (auction.status === 'scheduled' || auction.status === 'draft') {
    return (
      <span title={format.utc(auction.startsAt)}>
        {t('when.startsAt', { when: format.dateTime(auction.startsAt) })}
      </span>
    );
  }
  const ended = auction.endedAt ?? auction.cancelledAt ?? auction.endsAt;
  return (
    <span className="text-muted-foreground" title={format.utc(ended)}>
      {t('when.endedAt', { when: format.dateTime(ended) })}
    </span>
  );
}
